import React, {useCallback, useContext} from 'react';
import { Col } from 'react-bootstrap';
import {AgendaContext} from '../AgendaContextProvider';
import backToAgenda from '../../../../utils/backToAgendaAction';
import { sendCustomClick } from '../../../../utils/SnowplowUtils';
import { buttonTypes } from '../../../../constants/SnowplowConst';

export default ({ showControlPanel, setVirtualSessionDetails }) => {
    const { isWidget, serverRendered, event } = useContext(AgendaContext);
    const backToAgendaHandler = useCallback((e) => {
        sendCustomClick(buttonTypes.backButton, '', e.currentTarget);
        backToAgenda({ isWidget, serverRendered, event });
        setVirtualSessionDetails(null, null);
    }, [isWidget, serverRendered, event]);

    return showControlPanel ?
        <Col className='session-control-buttons'>
            <button
                className='control-button back-to-agenda font-size-12 custom-color color-1-background'
                onClick={backToAgendaHandler}
            >
                back
            </button>
        </Col> : null;
};
